"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PREFIX = '$LOCK$:';
class Lock {
    constructor(id) {
        this.PREFIX = PREFIX;
        this.id = id || parseInt('' + Date.now() + Math.floor(Math.random() * 1000));
    }
    toJSON() {
        return this.stringify();
    }
    stringify() {
        return `${this.PREFIX}${this.id}`;
    }
    static parse(id) {
        if (typeof id !== 'string' || id.indexOf(this.PREFIX) !== 0) {
            throw new Error('Invalid lock id format');
        }
        return new Lock(parseInt(id.replace(this.PREFIX, '')));
    }
    static isLock(possibleLock) {
        if (possibleLock instanceof Lock) {
            return true;
        }
        try {
            const lock = Lock.parse(possibleLock);
            return lock instanceof Lock;
        }
        catch (error) {
            return false;
        }
    }
    static compareLocks(possibleLock1, possibleLock2) {
        if (!(possibleLock1 instanceof Lock)) {
            try {
                possibleLock1 = this.parse(possibleLock1);
            }
            catch (error) {
                return false;
            }
        }
        if (!(possibleLock2 instanceof Lock)) {
            try {
                possibleLock2 = this.parse(possibleLock2);
            }
            catch (error) {
                return false;
            }
        }
        return possibleLock1.id === possibleLock2.id;
    }
}
Lock.PREFIX = PREFIX;
exports.Lock = Lock;
exports.default = Lock;
//# sourceMappingURL=Lock.js.map